import {
  forwardRef,
  useCallback,
  useContext,
  useImperativeHandle,
  useState,
} from 'react'
import { FiX } from 'react-icons/fi'

import { Modal } from '~/components/Modal'
import { CreateAdminForm } from '~/forms/CreateAdminForm'
import { CreateAdminFormType } from '~/forms/CreateAdminForm/schema'
import { createAdmin } from '~/modules/admin/services'

import { managersContext } from '../context'

export type CreateAdminModal = {
  showModal(): void
  hideModal(): void
}

const Component: React.ForwardRefRenderFunction<CreateAdminModal> = (
  _,
  ref,
) => {
  const { handleResetList } = useContext(managersContext)
  const [visible, setVisible] = useState<boolean>(false)

  useImperativeHandle(ref, () => ({
    showModal: () => {
      setVisible(true)
    },
    hideModal: () => {
      setVisible(false)
    },
  }))

  const handleCloseModal = useCallback(() => {
    setVisible(false)
  }, [])

  const handleSubmit = useCallback(
    async (payload: CreateAdminFormType) => {
      await createAdmin(payload)
      setVisible(false)
      if (payload) {
        handleResetList()
      }
    },
    [handleResetList],
  )

  return (
    <Modal visible={visible}>
      <div>
        <div className='flex items-center justify-between mb-4'>
          <h1 className='text-xl'>Novo Administrador</h1>
          <button
            type='button'
            className='p-2 rounded-full hover:bg-slate-50'
            onClick={handleCloseModal}
          >
            <FiX size={26} />
          </button>
        </div>

        <CreateAdminForm onSubmit={handleSubmit} />
      </div>
    </Modal>
  )
}

export const CreateAdminModal = forwardRef(Component)
